import React, { useState } from 'react';
import MatchingHalvesExercise from './MatchingHalvesExercise';
import './MatchingHalvesExerciseBoard.css';

const MATCHING_HALVES_ICON = (
  <span style={{
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 48, height: 48, borderRadius: 12, background: 'linear-gradient(135deg, #db2777 0%, #ec4899 100%)', marginRight: 20
  }}>
    <svg height="26" viewBox="0 0 512 512" width="26" xmlns="http://www.w3.org/2000/svg" fill="white">
      <path d="m0 271c0 126.019531 99.394531 232.195312 225.019531 240.472656l15.980469.527344v-481.527344l-15.980469 1.054688c-125.625 8.277344-225.019531 113.453125-225.019531 239.472656zm0 0"/>
      <path d="m286.980469 1.054688-15.980469-1.054688v481.527344l15.980469-1.054688c125.625-8.277344 225.019531-113.453125 225.019531-239.472656s-99.394531-231.667969-225.019531-239.945312zm0 0"/>
    </svg>
  </span>
);

const MatchingHalvesExerciseBoard = ({
  exerciseData, exerciseType: _exerciseType, onUpdate, isSelected, onSelect, onExpand,
  isExpanded: isExpandedProp, onClose,
  isStudent = false, myState = {}, otherState = {}, updateState = () => {},
}) => {
  const [isExpandedLocal, setIsExpandedLocal] = useState(false);
  const isExpanded = isExpandedProp !== undefined ? isExpandedProp : isExpandedLocal;
  const { sentences, title, level } = exerciseData;

  if (!sentences || !Array.isArray(sentences)) {
    return (
      <div className="matching-halves-board-error">
        <p>Error: Invalid Matching Halves exercise data</p>
      </div>
    );
  }

  return (
    <div className="matching-halves-exercise-board">
      {!isExpanded ? (
        <div
          className={`matching-halves-preview unified-exercise-preview mh-board-card${isSelected ? ' is-selected' : ''}`}
          onClick={() => {
            if (isExpandedProp === undefined) setIsExpandedLocal(true);
            if (onSelect) onSelect();
            if (onExpand) onExpand();
          }}
        >
          {MATCHING_HALVES_ICON}
          <div className="unified-preview-main">
            <div className="unified-preview-title">{title || 'Sentence Matching Exercise'}</div>
            <div className="unified-preview-meta">
              {sentences.length === 1 
                ? '1 sentence to match' 
                : `${sentences.length} sentences to match`} · Level: {level || 'B1'}
            </div>
          </div>
          <button className="unified-preview-btn">
            Start Exercise
          </button>
        </div>
      ) : (
        <div className="matching-halves-expanded">
          <MatchingHalvesExercise
            sentences={sentences}
            title={title}
            level={level}
            onClose={() => { if (isExpandedProp === undefined) setIsExpandedLocal(false); if (onClose) onClose(); }}
            onUpdate={onUpdate}
            isBoard={true}
            isStudent={isStudent}
            myState={myState}
            otherState={otherState}
            updateState={updateState}
          />
        </div>
      )}
    </div>
  );
};

export default MatchingHalvesExerciseBoard; 